(ns practitest.frontend.components2.dashboard.charts.readiness-gauge
  (:require [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.svg :refer [render!]]
            [practitest.frontend.components2.tooltip :as t]
            [practitest.frontend.components2.dashboard.charts.readiness-gauge.helpers :as h]))

(declare svg)
(def config
  (let [start-angel (- (* Math/PI 0.8))
        arc-weight-ratio 0.14
        arc-radius       100]
    #:config
    {:arc-weight-ratio    arc-weight-ratio
     :arc-radius          arc-radius
     :arc-weight          (* arc-radius arc-weight-ratio)
     :icon-radius         7.5
     :tick-count          10
     :tick-length         6
     :tick-padding        6
     :tick-inset          0.45
     :tick-width          0.6
     :transition-duration 600
     :start-angle         start-angel
     :end-angle           (- start-angel)}))

(defmethod p/render! ::chart/readiness-gauge [chart ctx svg-el]
  (->> chart
       (merge config ctx)
       svg
       (render! svg-el)))

(def tooltip-text
  "Readiness Score is based on Coverage, Execution, and Remaining
  Defects, with weights shifting during the sprint, giving higher
  weight to defects toward the end. ")

(defn svg [{:keys        [rrqi not-available? toggle-tooltip!]
            :config/keys [tick-count arc-radius transition-duration]
            :as          ctx}]
  (let [arc-bg    (h/arc ctx)
        arc-value (assoc arc-bg :to [:t (or rrqi 0)])
        tick      (h/tick ctx)
        tooltip!  #(toggle-tooltip! {:text    tooltip-text
                                     :element (.-currentTarget %)})]
    [:svg {:view-box [:svg/polar arc-radius]}
     [:svg/arc.arc-bg arc-bg]
     [:svg/transition {:duration transition-duration}
      [:svg/arc.arc-value arc-value]]

     (for [i (range (inc tick-count))]
       [:svg/line (merge tick {:angle [:t (/ i tick-count)]})])

     (if not-available?
       [:text.value-text "N/A"]
       [:g {:on-mouse-enter tooltip!
            :on-mouse-leave tooltip!}
        [:svg/vstack
         [:text.value-text rrqi]
         [:svg/hstack {:gap 4}
          (h/status-icon ctx)
          [:text.label-text "Readiness Score"]]]])]))
